(function (document, window) {
	// Reference: http://osvaldas.info/auto-hide-sticky-header
	const topBar = '.pusher .page-head';
	const topBarClassHidden = 'page-head--is-hidden';
	const bottomWrapper = '.bottom-wrapper';
	const bottomWrapperClassHidden = 'bottom-wrapper--is-hidden';
	const throttleTimeout = 500;
	const elementtopBar = document.querySelector(topBar);
	const elementBottomWrapper = document.querySelector(bottomWrapper);
	const container = document.querySelector('.content')

	let dHeight = 0;
	let wHeight = 0;
	let wScrollCurrent = 0;
	let wScrollBefore = 0;
	let wScrollDiff = 0;

	function addElementClass(element, className) {
		element.classList ? element.classList.add(className) : element.className += ` ${className}`;
	}

	function removeElementClass(element, className) {
		element.classList ? element.classList.remove(className) : element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
	}

	function hideHeader() {
		if (elementtopBar) {
			addElementClass(elementtopBar, topBarClassHidden);
		}
	}

	function hideFooter() {
		if (elementBottomWrapper) {
			addElementClass(elementBottomWrapper, bottomWrapperClassHidden);
		}
	}

	function showHeader() {
		if (elementtopBar) {
			removeElementClass(elementtopBar, topBarClassHidden);
		}
	}

	function showFooter() {
		if (elementBottomWrapper) {
			removeElementClass(elementBottomWrapper, bottomWrapperClassHidden);
		}
	}

	function throttle(delay, fn) {
		let last;
		let deferTimer;
		return function timerHideBars(...args) {
			const context = this;
			const now = +new Date();
			if (last && now < last + delay) {
				clearTimeout(deferTimer);
				deferTimer = setTimeout(() => {
					last = now;
					fn.apply(context, args);
				}, delay);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	}


	container && container.addEventListener('scroll', throttle(throttleTimeout, (e) => {
		dHeight = e.target.scrollHeight;
		wHeight = window.innerHeight;
		wScrollCurrent = e.target.scrollTop;
		wScrollDiff = wScrollBefore - wScrollCurrent;

		if (wScrollCurrent <= 0 || wScrollDiff > 0) {
			// scrolled to the very top; element sticks to the top
			showHeader();
			showFooter();
		} else if (wScrollDiff < 0) {
			// when scroll down
			if (wScrollCurrent + wHeight >= dHeight) {
				// scrolled to the very bottom; element slides in
				showHeader();
				showFooter();
			} else {
				// scrolled down; element slides out
				hideHeader();
				hideFooter();
			}
		}

		wScrollBefore = wScrollCurrent;
	}));
}(document, window));



// WEBPACK FOOTER //
// ./mobile-core/src/libs/scroll-hidebars.js